var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffiliates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5415 21.1404C29.3853 21.1404 30.229 24.5088 30.229 24.5088C31.0728 25.3509 32.7603 24.5088 32.7603 24.5088C34.8696 26.614 29.3853 30.4035 29.3853 31.2456C29.3853 32.0877 31.4946 32.5088 30.229 33.7719C29.5143 34.5059 28.6515 35.08 27.6978 35.4561C27.6978 39.6667 23.479 39.6667 22.6353 39.6667C21.7915 39.6667 20.104 36.2983 20.104 35.4561C20.104 34.614 20.9478 33.7719 20.9478 32.9298C20.9478 32.0877 19.2603 30.4035 19.2603 30.4035C19.2603 27.0351 16.729 27.8772 14.1978 27.8772C11.6665 27.8772 11.6665 24.5088 11.6665 24.5088C11.6665 24.5088 11.6665 18.614 15.8853 17.7719C20.104 16.9298 20.104 18.614 20.104 18.614C21.7915 20.2982 25.1665 18.614 26.854 18.614C26.854 18.614 27.6978 12.7193 26.0103 13.5614C24.3228 14.4035 22.8124 13.7551 22.6353 11.8772",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6665 26.1667C43.6665 36.9362 34.9361 45.6667 24.1665 45.6667C13.397 45.6667 4.6665 36.9362 4.6665 26.1667C4.6665 15.3971 13.397 6.66669 24.1665 6.66669",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6665 10.6667C46.6665 15.0827 38.6665 26.6667 38.6665 26.6667C38.6665 26.6667 30.6665 15.0827 30.6665 10.6667C30.6665 8.54496 31.5094 6.51012 33.0096 5.00983C34.5099 3.50954 36.5448 2.66669 38.6665 2.66669C40.7882 2.66669 42.8231 3.50954 44.3234 5.00983C45.8236 6.51012 46.6665 8.54496 46.6665 10.6667V10.6667Z",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6665 13.6667C40.3234 13.6667 41.6665 12.3235 41.6665 10.6667C41.6665 9.00983 40.3234 7.66669 38.6665 7.66669C37.0096 7.66669 35.6665 9.00983 35.6665 10.6667C35.6665 12.3235 37.0096 13.6667 38.6665 13.6667Z",
    fill: "#FFD200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliates);
export default __webpack_public_path__ + "static/media/affiliates.d720d89025eb6568e8355fbff191bbf8.svg";
export { ForwardRef as ReactComponent };